import { useAuth0 } from "@auth0/auth0-react";

function LogoutAuth0() {
  const { logout } = useAuth0();

  const handleLogout = async () => {
    console.log("Starting logout process...");
    
    try {
      // 1. Clear browser storage first
      localStorage.clear();
      sessionStorage.clear();
      console.log("Browser storage cleared");
      
      // 2. Call backend to clear Flask session BEFORE Auth0 logout
      const response = await fetch('/logout', { 
        method: 'POST', 
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      const result = await response.json();
      console.log("Backend logout response:", result);
      
      // 3. Small delay to ensure backend processing completes
      await new Promise(resolve => setTimeout(resolve, 200));
      
    } catch (error) {
      console.error("Backend logout failed:", error);
      // Continue with Auth0 logout even if backend fails
    }
    
    console.log("Calling Auth0 logout...");
    
    // 4. Auth0 logout (this will redirect immediately)
    logout({
      logoutParams: {
        returnTo: "https://www.enlive.inc"
      }
    } );
  };

  return (
    <a
      className="enlive-nav-link"
      href="#"
      onClick={(e) => {
        e.preventDefault();
        handleLogout();
      }}
    >
      Log out
    </a>
  );
}

export default LogoutAuth0;
